export const LOAD_ACTIVITY_FIELDS_STARTED = "LOAD_ACTIVITY_FIELDS_STARTED";
export const LOAD_ACTIVITY_FIELDS_SUCCEEDED = "LOAD_ACTIVITY_FIELDS_SUCCEEDED";
export const LOAD_ACTIVITY_FIELDS_FAILED = "LOAD_ACTIVITY_FIELDS_FAILED";

export const UPDATE_ACTIVITY_FIELDS_STARTED = "UPDATE_ACTIVITY_FIELDS_STARTED";
export const UPDATE_ACTIVITY_FIELDS_SUCCEEDED = "UPDATE_ACTIVITY_FIELDS_SUCCEEDED";
export const UPDATE_ACTIVITY_FIELDS_FAILED = "UPDATE_ACTIVITY_FIELDS_FAILED";
